import { render, staticRenderFns } from "./GeodirBuilder.vue?vue&type=template&id=09f42a60&scoped=true"
import script from "./GeodirBuilder.vue?vue&type=script&lang=js"
export * from "./GeodirBuilder.vue?vue&type=script&lang=js"
import style0 from "./GeodirBuilder.vue?vue&type=style&index=0&id=09f42a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f42a60",
  null
  
)

export default component.exports